export enum LocationContactType {
	Mobile,
	Email
}
